import { get, set } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default Route.extend({
  router: service(),
  uploadContacts: service(),

  beforeModel() {
    // confirm a file has been uploaded
    if (get(this, 'uploadContacts.columns.length') === 0) {
      this.router.transitionTo('funds.fund.contacts.upload.file');
    }
  },

  afterModel(model) {
    set(model, 'currentStep', '3');
    this.uploadContacts.createContactObjects();
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
